import React, { Component } from 'react';
import {
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter
} from 'mdbreact';
import { Button } from 'reactstrap'

class ErrorModal extends Component {
  state = {
    modal: true
  }

  render() {
    return (
      <MDBContainer>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader><b>Error</b></MDBModalHeader>
          <MDBModalBody>
            <pre>{this.props.text}</pre>
          </MDBModalBody>
          <MDBModalFooter>
            <Button color="primary" size='sm' onClick={() => this.props.onCancelError()}>Ok</Button>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default ErrorModal;


// WEBPACK FOOTER //
// ./src/components/modals/ErrorModal.js